<script>
export default {
  name: 'WarningBi',

  props: {
    type: { type: String, default: 'empty' },
    close: { type: Boolean, default: false },
  },

  data() {
    return {
      warning: {
        empty: {
          icon: 'warning',
          color: 'yellow-dark',
          bg: 'warning',
        },
        await: {
          icon: 'await-validation',
          color: '#D4790D',
          bg: '#D4790D',
        },
        without: {
          icon: 'warning',
          color: 'yellow-dark',
          text: 'avisos',
          bg: 'gray',
        },
        break: {
          icon: 'error-close',
          color: 'danger',
          text: 'erros',
          bg: 'gray',
        },
        progress: {
          icon: 'timer-warning',
          color: 'yellow-dark',
          text: 'avisos',
          bg: 'gray',
        },
        successBi: {
          icon: 'check-circle',
          color: 'success',
          text: '',
          bg: 'gray',
        },
      },
    }
  },
}
</script>

<template>
  <div class="warning-bi" :class="type">
    <div class="d-flex align-items-center" style="flex: 1">
      <icon-svg
        :name="warning[type].icon"
        :color="warning[type].color"
        size="40"
      />

      <div class="text" style="margin-left: 19px">
        <slot name="description" />
      </div>
    </div>

    <div class="warning-actions">
      <slot class="warning-btn" name="button" />
      <v-btn v-if="close" icon @click="$emit('close')">
        <icon-svg name="close-circle" color="#8E8E8E" size="24" />
      </v-btn>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.warning-bi
  display: flex
  align-items: center
  justify-content: space-between
  border-radius: 10px
  padding: 10px 16px
  background: #F1F1F1
  position: relative
  gap: 62px

  .warning-info
    display: flex
    align-items: center
    gap: 19px

  .warning-actions
    display: flex
    align-items: center
    gap: 16px

  &::before
    content: ''
    position: absolute
    left: 0
    height: 75%
    width: 2px

  .text
    h1
      font-size: 18px
      color: #4B4B4B
      margin: 0

    p
      font-size: 14px
      font-weight: 400
      color: #4B4B4B
      margin-bottom: 0
      margin-top: 5px

.empty
  background: #E0AF0026
  &::before
    background-color: var(--yellow-dark)

.without
  &::before
    background-color: var(--yellow-dark)
.break
  &::before
    background-color: var(--danger)
.successBi
  &::before
    background-color: var(--success)
</style>
